module.exports = __webpack_public_path__ + "media/images/dd-logo2-22a0b1f3.svg";